import axios from "axios";
import { configUrl } from "config";

export const submitQuestionChoices = async (payload) => {
    try {
        const response = await axios.put(
            `${configUrl.AssessmentServer}/api/QuestionChoices`,
            payload
        );

        return response.data;
    } catch (error) {
        console.error("Submit QuestionChoices Error:", error);
        throw error;
    }
};